
import React from 'react';
import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import IntegrationFeaturesList from './IntegrationFeaturesList';

interface ConnectedIntegrationProps {
  integration: {
    name: string;
    slug: string;
    connectedFields: {
      label: string;
      value: string;
      mask?: boolean;
    }[];
    features: string[];
  };
  formValues: Record<string, any>;
  onDisconnect: (slug: string) => void;
}

const ConnectedIntegration: React.FC<ConnectedIntegrationProps> = ({ 
  integration, 
  formValues,
  onDisconnect 
}) => {
  return (
    <div className="space-y-4">
      <div className="p-4 bg-green-50 border border-green-100 rounded-md">
        <div className="flex items-center">
          <Check className="h-5 w-5 text-green-600 mr-2" />
          <p className="font-medium">Connected to {integration.name}</p>
        </div>
        <p className="text-sm text-gray-500 mt-1">Your {integration.name} account is successfully connected.</p>
      </div>
      <div className="grid gap-4">
        {integration.connectedFields.map((field) => (
          <div className="flex items-center justify-between" key={field.label}>
            <span className="text-sm text-gray-500">{field.label}</span>
            <span className="text-sm font-mono">
              {field.mask 
                ? ("••••••••••••" + String(formValues[field.value]).slice(-4))
                : (String(formValues[field.value]))
              }
            </span>
          </div>
        ))}
      </div>
      <div className="flex justify-end space-x-2">
        <Button variant="outline" onClick={() => onDisconnect(integration.slug)}>
          Disconnect
        </Button>
        <Button>
          {integration.slug === "mailchimp" ? "Sync Contacts" : "Sync Leads"}
        </Button>
      </div>
    </div>
  );
};

export default ConnectedIntegration;
